var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/review.eaeaa50e.png","uri@2x": __webpack_public_path__ + "static/media/review.9b8c49fe.png","uri@3x": __webpack_public_path__ + "static/media/review.3b7462ad.png",
    width: 115,
    height: 114
});